import { render, staticRenderFns } from "./pspModal.vue?vue&type=template&id=52bf2419&scoped=true&"
import script from "./pspModal.vue?vue&type=script&lang=js&"
export * from "./pspModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52bf2419",
  null
  
)

export default component.exports